export default __webpack_public_path__ + "static/media/rain-1-night.529c2373.svg";